"use client";

import NextLink from "next/link";
import { Link as ChakraLink, Box, Tooltip } from "@chakra-ui/react";
import { usePathname } from "next/navigation";

export default function NavigationLink({
  href,
  children,
  isMobile = false,
  isCollapsed = false,
}: {
  href: string;
  children: React.ReactNode;
  isMobile?: boolean;
  isCollapsed?: boolean;
}) {
  const pathname = usePathname();
  const isActive =
    pathname === href || (href !== "/" && pathname.startsWith(href));

  const linkContent = (
    <ChakraLink
      asChild
      display="flex"
      alignItems="center"
      justifyContent={isCollapsed ? "center" : "flex-start"}
      px={isCollapsed ? 2 : 4}
      py={2}
      borderRadius="md"
      fontWeight={isActive ? "semibold" : "medium"}
      bg={isActive ? "moveon.primaryLight" : undefined}
      color={isActive ? "moveon.primary" : undefined}
      _hover={{
        bg: isActive ? "moveon.primaryLight" : "moveon.inactive",
        color: isActive ? "moveon.primary" : "gray.900",
        textDecoration: "none",
      }}
      w={isMobile ? "full" : undefined}
      _focus={{ boxShadow: "none", outline: "none" }}
      transition="all 0.2s"
    >
      <NextLink href={href}>
        {isCollapsed ? (
          <Box fontSize="lg">{String(children).charAt(0).toUpperCase()}</Box>
        ) : (
          children
        )}
      </NextLink>
    </ChakraLink>
  );

  // Wrap in tooltip when collapsed to show full label
  if (isCollapsed) {
    return (
      <Tooltip.Root openDelay={300}>
        <Tooltip.Trigger asChild>{linkContent}</Tooltip.Trigger>
        <Tooltip.Positioner>
          <Tooltip.Content>{children}</Tooltip.Content>
        </Tooltip.Positioner>
      </Tooltip.Root>
    );
  }

  return linkContent;
}
